import React, { Component } from 'react'
import NavigatorMain from './NavigatorMain';
import ModalList from "./Modal/ModalList"
import { syncAccount } from '../action/investmentAction.js';
import { getTbuxyQis } from '../action/loginAction.js';
import { hashHistory } from 'react-router';
import { Toast } from 'antd-mobile/lib';

export default class Loginkah extends Component {
    state = {
        agreeIndex: 0,
        identityNumber: ""
    }

    goBack = () => {
        hashHistory.goBack();
    }
    onChangeText(e){
      this.setState({
        identityNumber:e.target.value
      })
    }
    goBacks = () => {
        if(this.state.agreeIndex=="1"){
            this.setState({
                agreeIndex: 0
            })
            }else{
            this.setState({
                agreeIndex: 1
            })
        }
    }

    componentDidMount(){
      console.log(window.localStorage.getItem("inviteCode"))
      if(window.localStorage.getItem("inviteCode")){
        this.setState({
          identityNumber: window.localStorage.getItem("inviteCode")
        })
      }
    }
    closeMoadl = ()=>{
        let { name, mobileNo, loginType, loginNo, _this, onFun } = this.props.location.state
        let pattern = /^1[0123456789]\d{9}$/;
        console.log(this.props.location.state)
        if(this.state.identityNumber.length>0){
          if(!pattern.test(this.state.identityNumber)){
              Toast.info('请输入正确格式邀请码', 2);
              return
          }
        }
        if(this.state.agreeIndex=="1"){
          _this.dispatch(syncAccount({name:name,loginType:loginType,loginNo:loginNo,mobileNo:mobileNo,invitationCode:this.state.identityNumber},()=>{
            _this.dispatch(getTbuxyQis({clientType:"APP",token:""},(val)=>{
                if(val){
                  hashHistory.go(-3);
                }
            }))
          },(msg)=>{
            Toast.info(msg,2);return
        }))
        }else{
          Toast.info("请先阅读并确认用户同步信息授权书",2);
          return
        }
    }
  render() {
    const img_arr = [require('../img/square@3x.png'),require('../img/squareHooks@3x.png')]
    let { name, mobileNo, loginType, loginNo} = this.props.location.state
    console.log(this.props)
    return (
        <div className="container" >
        <NavigatorMain>
          <div className="header black">
            <div onClick={()=>this.goBack()}><span className="headerLeftBtn"></span></div>
            <div>同步开户</div>
            <div></div>
          </div>
        </NavigatorMain>
        <div className='content'>
          <div className='login-bars'>
            系统即将为您开通华夏财富账户
          </div>
          <div className='login-bar'>
            <span >
              姓名：
            </span>
            <span >
              {name}
            </span>
          </div>
          <div className='login-bar'>
            <span >
              证件类型：
            </span>
            <span >
              身份证
            </span>
          </div>
          <div className='login-bar'>
            <span >
              证件号码：
            </span>
            <span >
                {loginNo}
            </span>
          </div>
          <div className='login-bar'>
            <span >
              手机号：
            </span>
            <span >
                {mobileNo}
            </span>
          </div>
          <div className='login-bar'>
            <span >
              邀请码：
            </span>
            <div style={{flex:1}}>
            <input autocomplete="off"
              style={{width:"100%"}}
              value={this.state.identityNumber}
              onChange={(e)=>this.onChangeText(e)}
              placeholder="（非必填）请输入推荐人手机号码"

              />
            </div>
          </div>
          <div style={{fontSize: 12, color: "#3a3e47", textAlign: "center", paddingTop: 10,display:"flex",alignItems:"center"}}><img style={{width:"0.4rem",height:"0.4rem"}} onClick={this.goBacks} src={img_arr[this.state.agreeIndex]} />我已阅读并同意《用户同步信息授权书》</div>
          <div onClick={this.closeMoadl}  style={{width:"90%",height:"0.7rem",border:"1px solid #000",display:"flex",alignItems:"center",justifyContent:"center",fontSize:"20px",marginTop:"20px",marginLeft:"5%",borderRadius:"5px"}}>确认开户</div>
        </div>
        {/* <ModalList onFun={(Bools)=>{this.setState({Bools:Bools})}} flag={this.state.tanCar} btnRight={"确认"} btnRightFun={this.closeMoadl} content={"为了方便您在华夏财富系统和华夏基金系统同步办理业务，请您阅读并确认《用户同步信息授权书》"} title={""} /> */}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Loginkah.js